"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var dateformat_1 = __importDefault(require("dateformat"));
require("./info.css");
var timeStr = function (timestamp) { return dateformat_1.default(Date.parse(timestamp), "h:MM TT"); };
var fullTimeStr = function (timestamp) {
    return dateformat_1.default(Date.parse(timestamp), "dddd, mmmm dS, yyyy, h:MM:ss TT");
};
var Info = function (props) {
    var user = props.user, timestamp = props.timestamp;
    return (react_1.default.createElement("div", { className: "info-container" },
        user.imageUrl && (react_1.default.createElement("img", { src: user.imageUrl, width: "18", height: "18", alt: user.name })),
        react_1.default.createElement("span", { className: "sender-name" }, user.name),
        react_1.default.createElement("span", { className: "message-timestamp", title: fullTimeStr(timestamp) },
            "(",
            timeStr(timestamp),
            ")")));
};
exports.default = Info;
